import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Layout'),
    children: [
      { path: '', name: 'Home', component: () => import('@/views/Home') },
      { path: 'products', name: 'Products', component: () => import('@/views/Products') },
      { path: 'product/:id', name: 'ProductDetail', component: () => import('@/views/ProductDetail') },
      { path: 'about', name: 'About', component: () => import('@/views/About') },
      { path: 'cases', name: 'Cases', component: () => import('@/views/Cases') },
      { path: 'case/:id', name: 'CaseDetail', component: () => import('@/views/CaseDetail') },
      { path: 'news', name: 'News', component: () => import('@/views/News') },
      { path: 'news/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail') },
      { path: 'contact', name: 'Contact', component: () => import('@/views/Contact') }
    ]
  },
  {
    path: '/v3mz',
    component: () => import('@/views/admin/Layout'),
    children: [
      { path: 'login', name: 'AdminLogin', component: () => import('@/views/admin/Login') },
      { path: '', redirect: '/v3mz/dashboard', meta: { requiresAuth: true } },
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/admin/Dashboard'), meta: { requiresAuth: true } },
      { path: 'home', name: 'AdminHome', component: () => import('@/views/admin/BannerManage'), meta: { requiresAuth: true } },
      { path: 'products', name: 'AdminProducts', component: () => import('@/views/admin/ProductManage'), meta: { requiresAuth: true } },
      { path: 'categories', name: 'AdminCategories', component: () => import('@/views/admin/CategoryManage'), meta: { requiresAuth: true } },
      { path: 'series', name: 'AdminSeries', component: () => import('@/views/admin/SeriesManage'), meta: { requiresAuth: true } },
      { path: 'cases', name: 'AdminCases', component: () => import('@/views/admin/CaseManage'), meta: { requiresAuth: true } },
      { path: 'news', name: 'AdminNews', component: () => import('@/views/admin/NewsManage'), meta: { requiresAuth: true } },
      { path: 'contacts', name: 'AdminContacts', component: () => import('@/views/admin/ContactManage'), meta: { requiresAuth: true } },
      { path: 'settings', name: 'AdminSettings', component: () => import('@/views/admin/Settings'), meta: { requiresAuth: true } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 前台公开路由（无需登录）
const publicPaths = ['/', '/products', '/product/', '/about', '/cases', '/case/', '/news', '/news/', '/contact']

router.beforeEach((to, from, next) => {
  // 如果访问登录页且已登录，重定向到dashboard
  if (to.path === '/v3mz/login') {
    const token = localStorage.getItem('admin_token')
    if (token) {
      next('/v3mz/dashboard')
      return
    }
  }

  // 先检查是否前台公开路由，直接放行
  const isPublic = publicPaths.some(path => to.path === path || to.path.startsWith(path))
  if (isPublic) {
    next()
    return
  }

  // 后台管理页面：未登录跳登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next({ path: '/v3mz/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
